import { Component, computed, effect, inject, output } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { NavigationEnd, Router, RouterModule } from "@angular/router";
import { filter, map } from "rxjs";
import { MaterialModule } from "../../../material";
import { UserRole } from "../../models/user-role.enum";
import { UserService } from "../../services/user.service";

@Component({
    selector: "app-site-nav",
    imports: [MaterialModule, RouterModule],
    templateUrl: "./site-nav.html",
    styleUrl: "./site-nav.scss",
})
export class SiteNav {
    navItemClick = output<void>();
    protected userService = inject(UserService);
    protected readonly filteredTabs = computed(() => {
        const role = this.userService.currentUser()?.role;

        const tabs = [
            {
                route: "",
                label: "Dashboard",
                icon: "dashboard",
                activeIcon: "dashboard_active",
            },
            {
                route: "policies",
                label: "Policy Declaration",
                icon: "policy_declaration",
                activeIcon: "policy_declaration_active",
            },
        ];

        const adminTabs = [
            {
                route: "product",
                label: "Product Management",
                icon: "product_management",
                activeIcon: "product_management_active",
            },
        ];

        const roleTabsMap: Record<string, any[]> = {
            [UserRole.Admin]: adminTabs,
            // [UserRole.Manager]: managerTabs,
        };

        const additionalTabs = (role && roleTabsMap[role]) ?? [];

        return [...tabs, ...additionalTabs];
    });
    private router = inject(Router);
    private currentSegment = toSignal(
        this.router.events.pipe(
            filter((e) => e instanceof NavigationEnd),
            map(() => this.router.url.split("?")[0]),
        ),
        { initialValue: this.router.url.split("?")[0] },
    );
    protected activeRoute = this.currentSegment();

    constructor() {
        effect(() => {
            this.activeRoute = this.currentSegment();
        });
    }

    protected getRoute(route: string): string {
        if (!route) {
            return `/`;
        }

        return `/${route}`;
    }

    protected routeToHome(): void {
        this.navItemClick.emit();
        void this.router.navigateByUrl(`/`);
    }
}
